import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import FormField from '../common/FormField';
import Alert from '../common/Alert';
import './MfaVerify.css';

const MfaVerify = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { verifyMfa, logout } = useAuth();
  const navigate = useNavigate();

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!code || code.length !== 6) {
      setError('Please enter a valid 6-digit code');
      return;
    }

    setLoading(true);
    setError('');
    try {
      await verifyMfa(code);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid verification code');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="mfa-verify">
      <h2 className="mfa-verify__title">Two-Factor Authentication</h2>
      <p className="mfa-verify__desc">Please enter the 6-digit code from your authenticator app.</p>
      
      {error && <Alert type="error" message={error} />}

      <form onSubmit={handleVerify} className="mfa-verify__form">
        <FormField
          label="Verification Code"
          name="code"
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="000000"
          required
          autoComplete="one-time-code"
        />
        
        <div className="mfa-verify__actions">
          <button type="button" className="btn-cancel" onClick={handleCancel}>
            Cancel
          </button>
          <button type="submit" className="btn-verify" disabled={loading || code.length !== 6}>
            {loading ? 'Verifying...' : 'Verify'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default MfaVerify;
